var ttComparison = {
  init: function (root_class) {
    var s = this;

    if (root_class == undefined) {
      root_class = document;
    }

    $(root_class).find('.cd-image-container').each(function () {
      var th = $(this);
      s.drags(th.find('.cd-handle'), th.find('.cd-resize-img'), th,
        th.find('.cd-image-label[data-type="original"]'),
        th.find('.cd-image-label[data-type="modified"]'));
    });

    //upadate images label visibility
    // $(window).on('resize', function(){
    //     $(root_class).find('.cd-image-container').each(function(){
    //         var th = $(this);
    //         s.updateLabel(th.find('.cd-image-label[data-type="modified"]'), th.find('.cd-resize-img'), 'left');
    //         s.updateLabel(th.find('.cd-image-label[data-type="original"]'), th.find('.cd-resize-img'), 'right');
    //     });
    // });
  },


  //draggable funtionality - credits to http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/
  drags: function (drag_el, resize_el, container, label_container, label_resize_el) {
    var s = this;

    drag_el.on("mousedown vmousedown", function (e) {
      drag_el.addClass('draggable');
      resize_el.addClass('resizable');

      var dragWidth = drag_el.outerWidth(),
        xPosition = drag_el.offset().left + dragWidth - e.pageX,
        containerOffset = container.offset().left,
        containerWidth = container.outerWidth(),
        minLeft = containerOffset + 10,
        maxLeft = containerOffset + containerWidth - dragWidth - 10;

      drag_el.parents().on("mousemove vmousemove", function (e) {
        var leftValue = e.pageX + xPosition - dragWidth;

        //constrain the draggable element to move inside his container
        if (leftValue < minLeft) {
          leftValue = minLeft;
        } else if (leftValue > maxLeft) {
          leftValue = maxLeft;
        }

        var widthValue = (leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth + '%';

        $('.draggable').css('left', widthValue).on("mouseup vmouseup", function () {
          $(this).removeClass('draggable');
          resize_el.removeClass('resizable');
        });

        $('.resizable').css('width', widthValue);

        // s.updateLabel(label_resize_el, resize_el, 'left');
        // s.updateLabel(label_container, resize_el, 'right');

      }).on("mouseup vmouseup", function (e) {
        drag_el.removeClass('draggable');
        resize_el.removeClass('resizable');
      });
      e.preventDefault();
    }).on("mouseup vmouseup", function (e) {
      drag_el.removeClass('draggable');
      resize_el.removeClass('resizable');
    });


  }

  // updateLabel: function (label, resize_el, position) {
  //   if (position == 'left') {
  //     (label.offset().left + label.outerWidth() < resize_el.offset().left + resize_el.outerWidth()) ? label
  //       .removeClass('is-hidden'): label.addClass('is-hidden');
  //   } else {
  //     (label.offset().left > resize_el.offset().left + resize_el.outerWidth()) ? label.removeClass('is-hidden'):
  //       label.addClass('is-hidden');
  //   }
  // }

}